import { nextTick } from 'vue';
import { createVNode, render } from 'vue';
import ScriptElement from "@/components/scripts/ScriptElement.vue";
import { useScriptStore } from "@/store/script";
import useHistory from "@/hooks/useHistory";
import useUpdateHistoryValue from '@/hooks/useUpdateHistoryValue';
import { analyticsScriptStep } from '@/api/analytics';
import { debounce } from 'lodash';
import { makeSearch } from '@/api/catalogs';
import useOffset from '@/hooks/useOffset';
import { statisticObject, sequence, addLastDuration, autoSaver } from '@/hooks/useStatistic.js';
const inputTypeForFocus = [1, 2, 3, 4, 5, 6, 7, 30];
const inputTypeForEntry = [1, 2, 3, 4, 5, 6, 30];
const selectTypeSearch = [32, 33];
const MultiSelectTypes = [10, 33];
const { offset, refreshOffset, increaseOffset } = useOffset();
export default {
    name: 'script-element',
    async mounted(el, binding) {
        const element = el.querySelector('element');
        if (!element)
            return;
        const id = element.id.toLowerCase();
        const currentElement = binding.value().elements.find((i) => String(i.id.toLowerCase()) === String(id));
        if (currentElement.value && MultiSelectTypes.includes(currentElement.type) && typeof currentElement.value === 'string') {
            currentElement.value = JSON.parse(currentElement.value);
        }
        if (currentElement.value && selectTypeSearch.includes(currentElement.type)) {
            const ids = currentElement.type === 33 ? currentElement.value : [currentElement.value];
            const data = await makeSearch(currentElement.props.catalogId, null, ids, 0);
            currentElement.props.active = currentElement.type === 33 ? data.items : data.items[0];
        }
        const step = binding.value().step;
        if (step.stop)
            currentElement.props.tempValue = currentElement.value;
        const steps = binding.value().steps;
        const sections = binding.value().sections;
        const elements = binding.value().elements;
        const required = step.required;
        const vnode = createVNode(ScriptElement, { element: currentElement, required, stop: step.stop,
            onUpdate: (value) => {
                const oldValue = Array.isArray(currentElement.value) ? [...currentElement.value] : currentElement.value;
                if (step.stop) {
                    currentElement.value = MultiSelectTypes.includes(currentElement.type) ? value : currentElement.value;
                    if (step.num === null)
                        return;
                    currentElement.props.tempValue = value;
                    steps.forEach((i) => {
                        if (i?.num > step?.num && (Array.isArray(value) ? !value.length : !value))
                            i.num = null;
                        i.last = false;
                        i.last = i?.num === step?.num;
                    });
                    sections?.forEach((i) => {
                        if (i?.priority > step?.sectionNum)
                            i.disabled = true;
                    });
                }
                if (!step.stop) {
                    currentElement.value = value;
                    if (!binding.value().demo) {
                        useUpdateHistoryValue(id, value);
                        useHistory();
                    }
                    if (currentElement.type !== 1) {
                        binding.value().navigate(elements, steps, sections, !step.last ? step : null);
                        debouncedSetAnalyticsScriptStep(step);
                    }
                }
                let currentModal;
                if (useScriptStore().modals?.length) {
                    const isValueArray = Array.isArray(value);
                    const checkValue = (val) => {
                        return Array.isArray(val) ? val.length : !!value;
                    };
                    const checkStrategy = (modal) => {
                        if (modal.strategy === 'and') {
                            if (isValueArray) {
                                return modal.value ? value.length === JSON.parse(modal.value).length && value.every((el) => JSON.parse(modal.value).includes(el)) : false;
                            }
                            else {
                                return modal.value ? JSON.parse(modal.value).includes(value) : false;
                            }
                        }
                        else if (modal.strategy === 'or') {
                            if (isValueArray) {
                                return modal.value ? value.some((el) => JSON.parse(modal.value).includes(el)) : false;
                            }
                            else {
                                return modal.value ? JSON.parse(modal.value).includes(value) : false;
                            }
                        }
                        else {
                            if (isValueArray) {
                                if (value.length) {
                                    return modal.value ? value.length === JSON.parse(modal.value).length && value.every((el) => JSON.parse(modal.value).includes(el)) : false;
                                }
                                else {
                                    return checkValue(oldValue) ? modal.value === '' : false;
                                }
                            }
                            else {
                                if (value) {
                                    return modal.value ? JSON.parse(modal.value).includes(value) : false;
                                }
                                else {
                                    return checkValue(oldValue) ? modal.value === '' : false;
                                }
                            }
                        }
                    };
                    currentModal = useScriptStore().modals?.filter((modal) => {
                        return modal.elementId === step.elementId && checkStrategy(modal);
                    });
                }
                if (currentModal && currentModal.length) {
                    binding.value().openModal(currentModal.length > 1 ? currentModal.filter((modal) => modal.strategy === 'and')[0] : currentModal[0]);
                }
                //@ts-ignore
                if (statisticObject.activity.length && statisticObject.activity[statisticObject.activity.length - 1].elementId === currentElement.id) {
                    const currentActivity = statisticObject.activity[statisticObject.activity.length - 1];
                    currentActivity.dur = Date.now() - currentActivity.createdAt;
                    currentActivity.elementValue = value;
                    currentActivity.stepId = step.id;
                }
                else {
                    addLastDuration();
                    statisticObject.activity.push({
                        sequence: sequence.value,
                        createdAt: Date.now(), //(new Date()).toISOString(),
                        dur: 0,
                        activityType: 'step',
                        stepId: step.id,
                        elementValue: value,
                        elementId: currentElement.id
                    });
                    sequence.value++;
                }
            },
            onScrollTo: (id) => {
                binding.value().scrollTo(`step-${id}`, binding.value().scroll);
            },
            onConfirmEntry: async () => {
                if (step.stop && inputTypeForEntry.includes(currentElement.type)) {
                    binding.value().jump(step);
                }
                if (!step.stop && currentElement.type === 1) {
                    binding.value().navigate(elements, steps, sections, !step.last ? step : null);
                    debouncedSetAnalyticsScriptStep(step);
                }
                if (step.autoSave) {
                    autoSaver.value = step.id;
                }
            },
            onSearch: async (str) => {
                currentElement.props.options = [];
                currentElement.props.loading = true;
                let ids = [];
                if (currentElement.value && selectTypeSearch.includes(currentElement.type) && !str) {
                    ids = currentElement.type === 33 ? currentElement.value : [currentElement.value];
                }
                const catalogs = await makeSearch(currentElement.props.catalogId, str || null, ids, 0);
                currentElement.props.options = catalogs.items;
                currentElement.props.loading = false;
            },
            onOpened: () => {
                if (selectTypeSearch.includes(currentElement.type)) {
                    currentElement.props.options = [];
                }
            },
            onActive: (evt) => {
                currentElement.props.active = evt;
            },
            onRefreshSearch: () => {
                refreshOffset();
            },
            onLoadMore: async (str) => {
                currentElement.props.loading = true;
                increaseOffset(20);
                const catalogs = await makeSearch(currentElement.props.catalogId, str || null, [], offset.value);
                currentElement.props.options.push(...catalogs.items);
                currentElement.props.loading = false;
            }
        });
        const div = document.createElement('div');
        div.className = `script__element type-${currentElement.type}`;
        element.replaceWith(div);
        render(vnode, div);
        if (step.stop && inputTypeForFocus.includes(currentElement.type)) {
            nextTick(() => {
                const baseAttribute = `[elementid="${currentElement.id}"]`;
                const inputSelector = currentElement.type !== 4 ? `${baseAttribute} input` : `${baseAttribute} textarea`;
                const inputElement = el.querySelector(inputSelector);
                if (inputElement instanceof HTMLElement) {
                    inputElement.focus();
                }
            });
        }
    },
};
const debouncedSetAnalyticsScriptStep = debounce((step) => {
    const { script, clientId, analyticsSteps, modals } = useScriptStore();
    if (analyticsSteps.has(step.id))
        return;
    const SESSION_ID = localStorage.getItem('crm-analytics-session-id');
    const now = new Date();
    const createdAt = now.toISOString();
    const analyticStepData = {
        sessionId: SESSION_ID,
        scriptId: script?.id,
        scriptVersion: script?.version,
        stepId: step.id,
        clientId: clientId || 0,
        createdAt
    };
    analyticsScriptStep(analyticStepData);
    analyticsSteps.set(step.id, analyticStepData);
}, 500);
